import React, { Component } from 'react';
import {
  Select,
  LabeledSelect,
  LabeledSwitcher,
  Switcher,
} from '@nextiva/next-ui';

import optionRenderer from '../optionRenderer';

const getInputComponent = (options, showLabels) => {
  const isCheckbox = options?.length === 1;
  const SelectComponent = showLabels ? LabeledSelect : Select;
  const SwitcherComponent = showLabels ? LabeledSwitcher : Switcher;

  return isCheckbox ? SwitcherComponent : SelectComponent;
};

export default class SelectorComponent extends Component {
  render() {
    const { options, defaultOption, showLabels } = this.props;
    const SelectingComponent = getInputComponent(options, showLabels);

    return (
      <SelectingComponent
        {...this.props}
        options={[defaultOption, ...options]}
        labelAlign="out"
        kind="narrow"
        optionRenderer={optionRenderer}
      />
    );
  }
}
